import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

import 'flickity-imagesloaded';
import ProductCard from '../components/product-card';

export default register('featured-products', {
  onLoad() {
    this.sliderId = `#featured-products__slider--${this.id}`;
    const thisSlider = document.querySelector(`#featured-products__slider--${this.id}`);
    const productCards = thisSlider.querySelectorAll('.product-card');
    if (productCards.length > 0) {
      productCards.forEach((product) => ProductCard(product));
    }

    // eslint-disable-next-line no-unused-vars
    const flickity = new Flickity(thisSlider, {
      // options
      freeScroll: false,
      prevNextButtons: true,
      pageDots: true,
      imagesLoaded: true,
      setGallerySize: true,
      cellAlign: 'left',
      watchCSS: true,
      contain: true,
      groupCells: true,
      arrowShape: 'm12.075 51.432 27.04 23.66L36.572 78 4 49.5 36.571 21l2.545 2.908-27.04 23.66H95.8v3.864H12.075Z',
    });
  },
});
